export default __webpack_public_path__ + "static/media/doctor.cf59bb07.jpg";